exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-name[data-v-178e6126]{font-size:2em}h1[data-v-178e6126],h2[data-v-178e6126]{font-weight:400}p[data-v-178e6126]{font-weight:lighter;font-size:.8em;margin:0!important}ul[data-v-178e6126]{list-style-type:none;padding:0}li[data-v-178e6126]{display:inline-block;margin:0 10px}a[data-v-178e6126]{color:#42b983}.bwo-title-inline[data-v-178e6126]{display:inline}.bwo-menu-row[data-v-178e6126]{margin-left:0!important;margin-right:0!important}.item-content[data-v-178e6126]{margin:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-178e6126","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/FoodMenu.vue
// module id = 488
// module chunks = 0